export default __webpack_public_path__ + "static/media/Bronze.e5b9aea2.png";